export const NumberInput = {
  defaultProps: {
    focusBorderColor: 'brand.secondary',
  },
}
